<template>
  <div>
    <lottie
      :height="100"
      :width="100"
      :options="options"
      @animCreated="initAnim"
      class="icon"
      @click.native="changeFrame"
    >
    </lottie>
  </div>
</template>

<script>
import index from './index.vue'
import animationData from '../../assets/lottieJson/like.json'
export default {
  name: 'like',
  data() {
    return {
      options: {
        animationData:
          'https://assets2.lottiefiles.com/packages/lf20_j6autaxn.json',
        autoplay: false,
        loop: false
      },
      flag: true
    }
  },

  methods: {
    initAnim(data) {
      this.anim = data
      this.anim.setSpeed(2)
      if (this.flag) {
        this.anim.goToAndStop(19, true)
      }
    },
    changeFrame() {
      this.flag = !this.flag
      if (this.flag) {
        //添加动画
        this.anim && this.anim.play()
        // this.anim && this.anim.playSegments([0, 40], true)
      } else {
        //去处动画
        this.anim && this.anim.stop()
        // this.anim && this.anim.playSegments([0, 40], true)
      }
    }
  },
  components: {
    lottie: index
  }
}
</script>

<style scoped>
.icon {
  cursor: pointer;
}
</style>
